import React from "react";
import { t } from "ttag";

import styles from "./AttributeList.module.scss";

interface IAttributeListProps {
    list: {
        title: string;
        class: string;
    }[];
}

export const AttributeList = (
    props: IAttributeListProps,
): React.JSX.Element => {
    if (!props.list || props.list.length === 0) {
        return (
            <div className={styles.attributes}>
                <h3>{t`Feel data is not available`}</h3>
            </div>
        );
    }
    return (
        <div className={styles.attributes}>
            <h3>{t`Available Feels`}:</h3>
            <ul className={styles.list}>
                {props.list.map((item) => (
                    <li
                        key={`${item.title}-${item.class}`}
                        className={`${styles.item}`}
                    >
                        <span className={`${item.class} attribute-icon`}></span>
                        <span>{item.title}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};
